import { ContactEditorState } from './contact-editor.state';
import { emptyCard } from '../../constants/empty-card';
import { Action, createReducer, on } from '@ngrx/store';
import {
    contactEditorLoadComplete,
    contactEditorLoadFailure,
    contactEditorLoadRequest,
    contactEditorNew,
    contactEditorSaveFailure,
    contactEditorSaveRequest, contactEditorSaveSuccess,
    contactEditorSetAddressBookId,
    contactEditorSetCard,
    contactEditorSetId,
    contactEditorSetReference
} from './contact-editor.actions';

const initialState: ContactEditorState = {
    id: null,
    addressBookId: null,
    reference: null,
    card: emptyCard,
    loading: false,
    saving: false
};

const reducer = createReducer(
    initialState,
    on(contactEditorNew, () => (initialState)),
    on(contactEditorLoadRequest, (state) => ({ ...state, loading: true })),
    on(contactEditorLoadFailure, (state) => ({ ...state, loading: false })),
    on(contactEditorSaveRequest, (state) => ({ ...state, saving: true })),
    on(contactEditorSaveFailure, (state) => ({ ...state, saving: false })),
    on(contactEditorSaveSuccess, (state) => ({ ...state, saving: false })),
    on(contactEditorSetId, (state, { id }) => ({ ...state, id })),
    on(contactEditorSetCard, (state, { card }) => ({ ...state, card: { ...state.card, ...card } })),
    on(contactEditorSetReference, (state, { reference }) => ({ ...state, reference })),
    on(contactEditorSetAddressBookId, (state, { addressBookId }) => ({ ...state, addressBookId })),
    on(contactEditorLoadComplete, (state, { contact }) => ({
        ...state,
        addressBookId: contact.addressBookId,
        reference: contact.reference,
        card: { ...state.card, ...contact.card },
        loading: false,
        saving: false,
        id: contact.id
    }))
);

export function contactEditorReducer(state: ContactEditorState | undefined, action: Action): any {
    return reducer(state, action);
}
